export const getIsOpen = (state) => state.stockSummaryModal.get('isOpen', false);

export const getIsLoading = (state) => state.stockSummaryModal.get('isLoading', false);
